"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'promoterReviewe',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  props: {
    user_type: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    var _this = this;
    return {
      son_id: this.$route.query.son_id || '',
      form: {},
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      upbeginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.upend) {
            return time.getTime() > _this.form.upend || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      upendOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.upbegin) {
            return time.getTime() < _this.form.upbegin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      numInfo: {},
      stat_data: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        withdraw_status: this.$route.query.withdraw_status || '-1',
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      },
      statusObj: {
        0: '发起提现申请',
        1: '等待上级审核',
        2: '上级审核不通过',
        3: '等待最终审核',
        4: '最终审核不通过',
        5: '审核完毕, 返现中',
        6: '返现已到账并确认'
      },
      agentInfo: {}
    };
  },
  mounted: function mounted(options) {
    this.agentInfo = window.agentInfo;
    this.getNum();
    this.getList();
    this.$store.dispatch('user/postSetRecode', [1, 1, this.user_type]);
  },
  methods: {
    /**
     * 数量
     */
    getNum: function getNum() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        user_type: this.user_type
      });
      this.$get('agentapi/agent_withdraw_applys_stat_num', listQuery).then(function (res) {
        _this2.numInfo = res;
      });
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getNum();
      this.getList();
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab) {
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this3 = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
          start: this.listQuery.start - 1,
          user_type: this.user_type
        }),
        url = 'agentapi/my_reviewe_apply';
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      if (listQuery.upbegin) listQuery.upbegin = this.parseTime(listQuery.upbegin, '{y}-{m}-{d}');
      if (listQuery.upend) listQuery.upend = this.parseTime(listQuery.upend, '{y}-{m}-{d}');
      if (listQuery.withdraw_status == 2 && this.checkRoles(['partner', 'terminal'])) {
        listQuery.withdraw_status = 4;
      }
      this.$get(url, listQuery).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.list;
        _this3.stat_data = res.stat_data;
        _this3.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this3.tableMaxH = window.innerHeight - _this3.$refs.list_table.$el.offsetTop - 80;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    /**
     * 审核提现
     * @param {Object} row
     */
    upApply: function upApply(row, agree) {
      var _this4 = this;
      if (agree == 1) {
        this.$alert('确定该笔提现申请通过审核吗？', '提现审核', {
          confirmButtonText: '确定',
          callback: function callback(action) {
            if (action == 'confirm') {
              _this4.postApply(row, agree);
            }
          }
        });
      } else if (agree == 0) {
        this.$alert('确定驳回该笔提现申请吗？', '提现审核', {
          confirmButtonText: '确定',
          callback: function callback(action) {
            if (action == 'confirm') {
              _this4.postApply(row, agree);
            }
          }
        });
      }
    },
    virtualApply: function virtualApply(row) {
      var _this5 = this;
      this.$prompt('请输入备注', '人工处理', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            _this5.loadObj = _this5.$loading({
              lock: true,
              text: '正在提交',
              spinner: 'el-icon-loading'
            });
            var value = instance.inputValue;

            // 【操作埋点】2026-05-25 pc_withdraw_approve_1 人工处理提现
            _this5.$post('agentapi/virtual_review_apply', {
              apply_id: row.id,
              remarks: value
            }, {
              operation_option: '人工处理提现',
              content: "\u7533\u8BF7ID ".concat(row.id, "\uFF0C\u7528\u6237\u300C").concat(row.nick_name || '', "\u300D\u63D0\u73B0 ").concat(row.withdraw_money, " \u5143\uFF0C\u5907\u6CE8\uFF1A").concat(value || '无'),
              operation_id: 'pc_withdraw_approve_1'
            }).then(function (res) {
              _this5.loadObj.close();
              _this5.$message({
                message: '提交成功',
                type: 'success'
              });
              _this5.toQuery();
            }).catch(function (err) {
              _this5.loadObj.close();
            });
          } else {
            done();
          }
        }
      });
    },
    /**
     * 提交选择结果
     * @param {Object} id
     * @param {Object} agree
     */
    postApply: function postApply(row, agree) {
      var _this6 = this;
      var url = 'agentapi/upper_review_apply';
      if (agentInfo.agent_level == 1) url = 'agentapi/final_review_apply';

      // 【操作埋点】2026-05-25 pc_withdraw_approve_1 / pc_withdraw_reject_1 推广员提现审核
      this.$post(url, {
        apply_id: row.id,
        agree: agree
      }, agree == 0 ? {
        operation_option: '驳回提现',
        content: "\u7533\u8BF7ID ".concat(row.id, "\uFF0C\u7528\u6237\u300C").concat(row.nick_name || '', "\u300D\u7533\u8BF7\u63D0\u73B0 ").concat(row.withdraw_money, " \u5143"),
        operation_id: 'pc_withdraw_reject_1'
      } : {
        operation_option: '审核通过提现',
        content: "\u7533\u8BF7ID ".concat(row.id, "\uFF0C\u7528\u6237\u300C").concat(row.nick_name || '', "\u300D\u63D0\u73B0 ").concat(row.withdraw_money, " \u5143\uFF0C\u624B\u7EED\u8D39 ").concat(row.withdraw_service_fee || 0, " \u5143\uFF0C\u5230\u8D26 ").concat(row.withdraw_money_get, " \u5143"),
        operation_id: 'pc_withdraw_approve_1'
      }).then(function (res) {
        _this6.$message({
          message: '提交成功',
          type: 'success'
        });
        if (agentInfo.agent_level == 1) {
          if (row.withdraw_type == 0 || row.withdraw_type == 3 || row.withdraw_type == 4) {
            row.withdraw_status = agree == 0 ? 4 : 6;
          } else {
            row.withdraw_status = agree == 0 ? 4 : 5;
          }
        } else {
          row.withdraw_status = agree == 0 ? 2 : 3;
        }
      });
    }
  }
};